import React from "react";
import { withStyles } from "material-ui";

import { P, RegularCard, Button } from "components";
import LocalParking from "@material-ui/icons/LocalParking";
import Send from "@material-ui/icons/Send";

import logo from "assets/icon/hexagon-dark+text.svg";

const style = {
    typo: {
        paddingLeft: "25%",
        marginBottom: "40px",
        position: "relative"
    },
    note: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        bottom: "10px",
        color: "#c0c1c2",
        display: "block",
        fontWeight: "400",
        fontSize: "13px",
        lineHeight: "13px",
        left: "0",
        marginLeft: "20px",
        position: "absolute",
        width: "260px"
    }
};

const address = '0x3797cf7779fe48161afe2ee1c10567bd32e6e9d5';

class About extends React.Component {
    render() {
        return (
            <RegularCard
            hideHeader={true}
            content={
            <div>

              <h2>About</h2>
              <P>
                <b>DappStore</b> is a platform, which lists all popular dApps (decentralized applications). Discover the innovative world of blockchain, plus explore the many decentralized applications in our platform. Dapps are ranked by DAU and shows the real popularity and usability of the dapp.
              </P>
              <P>
                We already have a really wonderful team contributing to the growth of the project, and our goal is to connect ÐApp creators and users.
              </P>
              <P>You can support DAppStore with an Ethereum donation. Your donation will help improve the platform!<br />
Addresses: {address}</P>

              <img src={logo} alt="DAppStore"/>

              <div style={{
                textAlign: "center"
            }} >
              <Button href="https://www.producthunt.com/posts/dapp-store" target="_blank" rel="noopener" color="warning" style={{
                backgroundColor: '#f66330',
            }} >
              <span style={{
                backgroundColor: 'white',
                borderRadius: '50%',
            }}>
                  <LocalParking style={{
                color: '#f66330',
                width: '14px',
                margin: '3px',
                height: '14px',
            }} />
                  </span>   Check us out on ProductHunt
              </Button>
              </div>

             <h2>Advertise Dapps</h2>
            <P>
Advertise a Dapp on the table on the home page for 24 hours, 1 week or 10 days.<br />
<div style={{
                padding: "10px"
            }}>
<b>24 hours</b> - 0.25 ETH<br />
<b>1 week</b> - 1 ETH<br />
<b>10 days</b> - 1.5 ETH<br />
</div>
Addresses: {address}
              <div style={{
                textAlign: "center"
            }} >
 <Button href="https://t.me/RomanGladun" target="_blank" rel="noopener" color="info" style={{
            }} >
              <Send /> Advertise Dapp
              </Button>
              </div>
            </P>

              <h3>What is a Dapp?</h3>
              <P>Dapp is a Decentralized Application. Dapp can be a website, mobile app or something else. As long as the code responsible for main app logic is running on blockchain, it is a Dapp.</P>

              <h3>How can I use a Dapp?</h3>
              <P>You will need Ethereum to use a dapp. You can buy Ethereum on Coinbase or another provider. Once you own Ethereum you can send money to a Web3 Wallet. A Web3 wallet will let you interact with Dapps and access web 3.0.</P>

              <h3>How do you calculate Dapp Users?</h3>
              <P>Dapp users count is the number of unique wallet addresses interacting with the dapp’s smart contracts. Most of the time one user uses one wallet. However, manipulation of users count happens time by time and while we are trying to detect and exclude manipulated data, we can’t promise to filter out all of it.</P>

              <h3>How do I submit a Dapp?</h3>
              <P>You can submit a dapp to DappStore for free. Just go to "Submit Dapp" in the menu.</P>


          </div>
            }
            />
        );
    }
}

export default withStyles(style)(About);



// WEBPACK FOOTER //
// ./src/views/About/About.jsx